import { render, staticRenderFns } from "./RoomListItem.vue?vue&type=template&id=5fb00d44&lang=pug&"
import script from "./RoomListItem.vue?vue&type=script&lang=ts&"
export * from "./RoomListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomListItem.vue"
export default component.exports